export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10315.532d11dc.jpg";